import './App.css';
import {
  Box,
  Center,
  ChakraProvider,
  Image,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';

import CopilotLogo from '../src/assets/images/copilot.png';
import TUFooterLogo from '../src/assets/images/tu-footer-logo.png';

function App() {
  return (
    <ChakraProvider>
      <Box overflow="hidden">
        <Center
          bg="#fff"
          h={{ base: '8vh', md: '12vh' }}
          justifyContent="center"
          px={{ base: '2rem', md: '25vh', '2xl': '35vh' }}
          borderBottom="1px solid #D1DADF"
        >
          <Image src="./tu-logo.png" h={{ base: '2.5rem', md: '3rem' }} />
        </Center>
        <Center
          mx="auto"
          pos="relative"
          h={{ base: 'calc(100dvh - 6.3em)', md: '84vh' }}
          px={{ base: '1.5rem', md: '2rem' }}
        >
          <VStack
            spacing={{ base: '1rem', md: '1.25rem' }}
            maxW="640px"
            textAlign="center"
          >
            <Text
              fontSize={{ base: '1.75rem', md: '2.25rem' }}
              fontWeight="600"
              color="#1A202C"
              lineHeight="1.2"
            >
              Application Currently Unavailable
            </Text>
            <Text
              fontSize={{ base: '1rem', md: '1.125rem' }}
              color="#4A5568"
              lineHeight="1.6"
            >
              Thank you for your interest. This application is not available at
              the moment. We appreciate your patience and understanding.
            </Text>
            <Box
              mt={{ base: '0.5rem', md: '1rem' }}
              pt={{ base: '1rem', md: '1.5rem' }}
              borderTop="1px solid #E2E8F0"
              w="full"
            >
              <Text
                fontSize={{ base: '0.875rem', md: '1rem' }}
                color="#4A5568"
              >
                For further enquiries, please contact{' '}
                <Link
                  href="mailto:pavithra@cxunicorn.com"
                  color="#2B6CB0"
                  fontWeight="500"
                  _hover={{ textDecoration: 'underline' }}
                >
                  pavithra@cxunicorn.com
                </Link>
              </Text>
            </Box>
          </VStack>
        </Center>
      </Box>
      {/* Footer */}
      <Box
        h={{ base: '4vh', md: '4vh' }}
        display="flex"
        alignItems="center"
        pos="relative"
        zIndex={0}
        bg="#353535"
        color="white"
      >
        <Center
          display="flex"
          pos="absolute"
          w="full"
          justifyContent="center"
        >
          <Text fontSize="xs" me="0.4rem">
            Powered by
          </Text>
          <Image src={CopilotLogo} h="13px" />
          <Text overflow="hidden" h={{ base: '20px', md: '28px' }} px="1.5">
            |
          </Text>
          <Image src={TUFooterLogo} h="10px" />
        </Center>
      </Box>
    </ChakraProvider>
  );
}

export default App;
